import React, { Component } from 'react';
import { Button, Toolbar, Autocomplete, TextField } from 'react-md';
import '../Wizard.scss';
import { ProgressBar } from '../../index';

export default class OrgWizardStep1 extends Component {
  state = {
    displayName: '',
    autoCompleteKey: ''
  };

  componentDidMount() {
    const { data } = this.props;

    if (data) {
      this.setState({
        displayName: data.childName
      });
    }
  }

  handleNameChange = (data) => {
    this.setState({ displayName: data, autoCompleteKey: '' });
    this.props.actions.update({ displayName: data, autoCompleteKey: '' });
  }

  handleAutocomplete = (data) => {
    const { relationships } = this.props;
    const org = relationships.filter(x => x.childName === data)[0] ?
      relationships.filter(x => x.childName === data)[0] :
      this.props.orgList.filter(x => x.displayName === data)[0];
    const dupeOrgRelations = org &&
      org.relationships &&
        this.props.orgList.filter(x => (x.externalKey === org && org.childKey) ||
        x.externalKey === data.value)[0].relationships.filter(x => x.partyType === 'ORGANIZATION' && x.fromPartyKey).map((x, i) => {
          return {
            relationshipType: {
              label: x.relationshipType.split('_').join(' ').toLowerCase(),
              value: x.relationshipType
            },
            organization: {
              label: x.displayName,
              value: x.fromPartyKey
            },
            index: i,
            partyType: x.partyType,
            relationshipKey: x.relationshipKey
          };
        });

    if (org) {
      this.setState({ displayName: data, autoCompleteKey: org.childKey || org.externalKey });
      this.props.actions.update({ displayName: data, autoCompleteKey: org.childKey || org.externalKey, dupeOrgs: dupeOrgRelations });
    }
  }

  checkForDupe = () => {
    const { displayName } = this.state;
    const { relationships } = this.props;
    if (displayName !== (this.props.data && this.props.data.childName)) {
      return relationships.some(x => x.childName ? x.childName.toLowerCase() === displayName.toLowerCase() : false) ||
      this.props.orgList.some(x => x.displayName ? x.displayName.toLowerCase() === displayName.toLowerCase() : false);
    }
  }

  render() {
    const { displayName } = this.state;
    const { data, title, hide } = this.props;
    const autocompleteData = this.props.orgList && this.props.orgList.map(x => { return { name: x.displayName, id: x.externalKey, key: x.externalKey };});
    const errorMessage = () => {
      if (!data) {
        return this.checkForDupe() && ` The child organization ${displayName} already exists. Continuing will allow you to add a new parent relationship for ${displayName}`;
      } else {
        if (displayName !== data.childName) {
          return this.checkForDupe() && ` The child organization ${displayName} already exists. Please use another name`;
        }
      }


    };
    return (
      <div className="wrapper">
        <Toolbar
          fixed
          colored
          titleStyle={{ margin: '0 auto', paddingRight: ' 36px' }}
          title={data ? `Edit ${title.toLowerCase()}` : `Creating a new ${title.toLowerCase()}`}
          nav={<Button id="dialog-back-button" onClick={hide} icon >arrow_back</Button>}
          style={{ backgroundColor: '#6200EE' }}
        />
        <ProgressBar step={this.props.currentStep} steps={2} />
        <div className="wizard-step">
          <div className="wizard-step-header-container">
            <div className="wizard-step-header">What’s the name of the child organization?</div>
          </div>
          <div>
            {data ?
              <TextField
                id="organization-name-input"
                className="wizard-text-input"
                label="Name"
                value={displayName}
                onChange={(v) => this.handleNameChange(v)}
              />
              :
              <Autocomplete
                id="organization-name-input"
                className="wizard-text-input"
                label="Name"
                data={autocompleteData}
                dataLabel="name"
                filter={Autocomplete.caseInsensitiveFilter}
                value={displayName}
                onChange={(v) => this.handleNameChange(v)}
                onAutocomplete={this.handleAutocomplete}
                autocompleteWithLabel
              />}
            <div className="wizard-error">
              {errorMessage()}
            </div>
          </div>
          <div><Button className="wizard-button" disabled={!displayName || (data && this.checkForDupe())} flat onClick={this.props.nextStep} children="continue" /></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard/OrgWizardStep1/OrgWizardStep1.jsx